module.exports = __webpack_public_path__ + "static/media/alligned_old.741aaff1.jpg";